import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LandingComponent } from './landing/landing.component';
import { LayoutComponent } from './layout/layout.component';
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { CatalogComponent } from '../shared/catalog/catalog.component';
import { CmsPageComponent } from './cms-page/cms-page.component';
import { ContactUsComponent } from './contact-us/contact-us.component';

import { ElementsComponent } from './elements/elements.component';
import { AfterLoginLayoutComponent } from './after-login-layout/after-login-layout.component';

import { ForgetPasswordResetComponent } from './forget-password-reset/forget-password-reset.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import {AuthGuard} from './../shared/guard/auth.guard';
import { SearchComponent } from './search/search.component';
import {EdtechComponent} from './../home/edtech/edtech.component';
import { from } from 'rxjs';
import { CategoryBookListComponent } from './category-book-list/category-book-list.component';
import { ReciveAnnouncementComponent } from './recive-announcement/recive-announcement.component';
import { ViewMoreBookComponent } from './view-more-book/view-more-book.component';
import { ReadBookComponent } from './read-book/read-book.component';
const routes: Routes = [
  {
    path:'',
    component:LayoutComponent,
    children:[
      {
        path:'',
        component: LandingComponent
      },
      {
        path:'search',
        component:SearchComponent
      },
      {
        path:'page-not-found',
        component: PageNotFoundComponent
      },
      {
        path:'login',
        component: LoginComponent
      },
      {
        path:'signup',
        component: SignupComponent
      },
      {
        path:'verify/:token',
        component: LandingComponent
      },
      {
        path:'forgot-password',
        component: ForgotPasswordComponent
      },
      {
        path:'reset/:token',
        component: ForgetPasswordResetComponent
      },
      {
        path:'page/:pageSlug',
        component: CmsPageComponent
      },
      {
        path:'edtech',
        component: EdtechComponent
      },
      {
        path:'catalog',
        component: CatalogComponent
      },
      
      {
        path:'contact-us',
        component: ContactUsComponent
      },
      {
        path:'recive-announcement',
        component: ReciveAnnouncementComponent
      },
      {
        path:'elements',
        component: ElementsComponent
      },
      {
        path:'topics',
        loadChildren:'./topic/topic.module#TopicModule'
      },
      {
        path:'books',
        loadChildren:'./book/book.module#BookModule'
      },
      {
        path:'category-books/:id',
        component: CategoryBookListComponent
      },
      {
        path:'view-more-book',
        component: ViewMoreBookComponent
      },
      {
        path:'articles',
        loadChildren:'./article/article.module#ArticleModule'
      },
      {
        path:'educators',
        loadChildren:'./educator/educator.module#EducatorModule'
      },
      {
        path:'students',
        loadChildren:'./students/students.module#StudentsModule'
      },
      {
        path:'events',
        loadChildren:'./event/event.module#EventModule'
      },
      {
        path:'stores',
        loadChildren:'./store/store.module#StoreModule'
      },
      {
        path:'webinars',
        loadChildren:'./webinars/webinars.module#WebinarsModule'
      },
      {
        path:'order',
        //canActivate:[AuthGuard],
        loadChildren:'./cart/cart.module#CartModule'
      },
      {
        path:'blogs',
        loadChildren:'./blogs/blogs.module#BlogsModule'
      },
      //{
        //path:'success',
       // loadChildren:'./cart/order/success#SuccessOrderModule'
      //},

      
    ]
    
  },
  {
    path:'profile',
    component:AfterLoginLayoutComponent,
    canActivate:[AuthGuard],
    children:[
      {
        path:'',
        loadChildren:'./user/user.module#UserModule'
      },
    ]
  },
  {
    path:'my-books/:id/read',
    component: ReadBookComponent,
    canActivate:[AuthGuard],
  },
  { path: '**', redirectTo: 'page-not-found' },
];


@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
